import React from 'react';
import { reduxForm, change, submit } from 'redux-form';
import PropTypes from 'prop-types';
import Button from 'components/buttons/Button';
import ContactFormFields from '../../contact/ContactFormFields';


const ContactCreate = ({
  classes,
  handleSubmit,
  ...props
}) => {
  const onSubmit = async (addNext) => {
    await props.dispatch(change('ContactCreate', 'addNext', addNext));
    await props.dispatch(change('ContactCreate', 'next', !addNext));
    await props.dispatch(submit('ContactCreate'));
  };

  return (
    <form className="instance-form" autoComplete="off" onSubmit={handleSubmit}>
      <div className="instance-form__body">
        <ContactFormFields />
      </div>
      <div className="instance-form__footer mt-4 justify-content-end">
        <Button
          type="button"
          color="secondary"
          variant="textPrimaryContained"
          disabled={!props.valid || props.submitting}
          onClick={() => onSubmit(true)}
        >
          Save & Add Another
        </Button>
        <Button
          type="button"
          color="primary"
          variant="contained"
          className="ml-2"
          disabled={!props.valid || props.submitting}
          onClick={() => onSubmit(false)}
        >
          Add Contact
        </Button>
      </div>
    </form>
  );
};

ContactCreate.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  valid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default reduxForm({ form: 'ContactCreate' })(ContactCreate);
